import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import Router from 'next/router'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import Search from './search'

const QUERY = gql`
query SearchText($searchText: String!, $offset: Int) {
  search (searchText: $searchText, offset:$offset, limit: 36) {
    total,
    searchResults {
      headline
      object_id
      object_type
      url
      slug
      created_date,
      category
      series
    }
  }
}
`

export default function SearchWithData(props) {
  const { offset, searchText = '' } = props

  const handlePagination = (newOffset) => {
    Router.push(`/search?searchText=${searchText}&offset=${newOffset}`)
    window.scrollTo(0, 0)
  }
  const vars = {
    searchText,
    offset: Number(offset) || 0,
  }

  return searchText ? (
    <Query query={QUERY} variables={vars} context={{ clientName: 'pga-algolia' }}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data.search
        return (
          <Search {...props} {...response} handlePagination={handlePagination} />
        )
      }}
    </Query>
  ) : <Search {...props} searchText="" handlePagination={handlePagination} />
}

SearchWithData.propTypes = {
  offset: PropTypes.string,
  searchText: PropTypes.string,
}
